import { render, staticRenderFns } from "./DataBox.vue?vue&type=template&id=7d98edd5&scoped=true&"
import script from "./DataBox.vue?vue&type=script&lang=js&"
export * from "./DataBox.vue?vue&type=script&lang=js&"
import style0 from "./DataBox.vue?vue&type=style&index=0&id=7d98edd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98edd5",
  null
  
)

export default component.exports